import EX403 from "../../assets/svg/403.svg";
import EX404 from "../../assets/svg/404.svg";
import EX500 from "../../assets/svg/500.svg";

const config = {
  403: {
    img: EX403,
    title: "403",
    desc: "抱歉，你无权访问该页面",
  },
  404: {
    img: EX404,
    title: "404",
    desc: "抱歉，你访问的页面不存在",
  },
  500: {
    img: EX500,
    title: "500",
    desc: "抱歉，服务器出错了",
  },
};

export default config;
